import RegulationPage from "components/carModelPage/sections/specifications/RegulationPage"

const SpecificationsSection = ({ carData }) => {
  return (
    <RegulationPage data={carData?.regulation} catalog={carData?.catalogs} />
  )
}

export default SpecificationsSection
